<app-auth-form
  [isRegister]="isRegister"
  [errorMessage]="errorMessage"
  [showSuccessState]="showSuccessState"
  (formSubmit)="onRegister($event)"
></app-auth-form>
